import React from 'react';
import { useDeviceDetection } from '../hooks/useDeviceDetection';
import ReportesListView from './ReportesListView';
import ReportesListMovilView from './ReportesListMovilView';

/**
 * Vista automática que detecta el dispositivo y muestra
 * la versión apropiada de la lista de reportes
 */
const ReportesListAutoView: React.FC = () => {
  const { isMobile, isTablet } = useDeviceDetection();

  // Considerar tablets como móvil
  const esMobileOTablet = isMobile || isTablet;

  // Renderizar versión móvil o desktop según el dispositivo
  if (esMobileOTablet) {
    return <ReportesListMovilView />;
  }

  return <ReportesListView />;
};

export default ReportesListAutoView;
